(function () {
  'use strict';

  const page = (window.FoxTheme && window.FoxTheme.page) || {};

  // Initialize Agentic Commerce Personalization Engine
  const AgenticCommerce = {
    models: {
      transformerId: 'model_1759421305895_digot6jhr',
      coordinationId: 'model_coordination_1759421306203',
    },

    // Track user intent based on trained patterns
    trackIntent: function () {
      const pageType = page.pageType;

      // Intent recognition patterns from neural training
      const intents = {
        product: 'product_discovery',
        collection: 'browsing',
        cart: 'checkout_intent',
        index: 'exploration',
        search: 'search_intent',
      };

      const currentIntent = intents[pageType] || 'general_browsing';

      // Store in session for personalization
      sessionStorage.setItem('ac_intent', currentIntent);
      sessionStorage.setItem('ac_page_sequence', this.getPageSequence());

      // Track product views for recommendations
      if (pageType === 'product') {
        this.trackProductView(page.product && page.product.id, page.product && page.product.title);
      }
    },

    // Track product interactions
    trackProductView: function (productId, productTitle) {
      let viewHistory = JSON.parse(localStorage.getItem('ac_viewed_products') || '[]');

      // Add to history if not already there
      if (!viewHistory.find((p) => p.id === productId)) {
        viewHistory.unshift({
          id: productId,
          title: productTitle,
          timestamp: Date.now(),
          category: (page.collection && page.collection.title) || 'uncategorized',
        });

        // Keep only last 20 views
        viewHistory = viewHistory.slice(0, 20);
        localStorage.setItem('ac_viewed_products', JSON.stringify(viewHistory));
      }

      // Fire custom event for other scripts
      window.dispatchEvent(
        new CustomEvent('ac:product-viewed', {
          detail: { productId, productTitle },
        })
      );
    },

    // Get page navigation sequence
    getPageSequence: function () {
      const sequence = JSON.parse(sessionStorage.getItem('ac_page_sequence') || '[]');
      sequence.push({
        type: page.pageType,
        path: page.path,
        timestamp: Date.now(),
      });
      return JSON.stringify(sequence.slice(-10)); // Keep last 10 pages
    },

    // Predict next action using coordination model
    predictNextAction: function () {
      const intent = sessionStorage.getItem('ac_intent');

      // Simple heuristic based on trained patterns
      const predictions = {
        product_discovery: ['add_to_cart', 'view_related', 'compare'],
        checkout_intent: ['complete_purchase', 'apply_discount', 'add_upsell'],
        browsing: ['filter_products', 'view_product', 'search'],
        search_intent: ['refine_search', 'view_product', 'clear_filters'],
      };

      return predictions[intent] || ['continue_browsing'];
    },

    // Get personalized recommendations
    getRecommendations: function () {
      const viewedProducts = JSON.parse(localStorage.getItem('ac_viewed_products') || '[]');
      const intent = sessionStorage.getItem('ac_intent');

      return {
        viewed: viewedProducts,
        intent: intent,
        nextActions: this.predictNextAction(),
      };
    },

    // Enhanced cart tracking
    trackCartAction: function (action, data) {
      const cartEvents = JSON.parse(sessionStorage.getItem('ac_cart_events') || '[]');
      cartEvents.push({
        action: action,
        data: data,
        timestamp: Date.now(),
        intent: sessionStorage.getItem('ac_intent'),
      });
      sessionStorage.setItem('ac_cart_events', JSON.stringify(cartEvents));

      // Trigger urgency if checkout intent detected
      if (action === 'add' && this.predictNextAction().includes('complete_purchase')) {
        this.showUrgencyIndicator();
      }
    },

    // Show urgency indicators for high-intent users
    showUrgencyIndicator: function () {
      const cartCount = page.cartItemCount;
      if (cartCount > 0) {
        // Signal to show urgency messaging
        document.body.setAttribute('data-ac-urgency', 'high');
      }
    },

    // Initialize on page load
    init: function () {
      this.trackIntent();

      // Make available globally
      window.AgenticCommerce = this;

      // Track cart interactions
      document.addEventListener('cart:updated', (e) => {
        this.trackCartAction('update', e.detail);
      });
    },
  };

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => AgenticCommerce.init());
  } else {
    AgenticCommerce.init();
  }
})();
